import {
  useChecklistSuspense,
  type ChecklistResponse
} from "@swivu/client-api";
import { createContext, useContext } from "react";
import { QueryClient } from "@tanstack/react-query";

export type ChecklistVariables =
  | {
      api: "wf";
      checklist_id: number;
      queryClient: QueryClient;
    }
  | {
      api: "public";
      checklist_id: number;
      slug: string;
      queryClient: QueryClient;
    };

type ChecklistValues = ChecklistVariables & {
  checklist: ChecklistResponse;
};

const ChecklistContext = createContext<
  (ChecklistVariables & ChecklistValues) | null
>(null);

export const ChecklistProvider = ({
  children,
  ...props
}: ChecklistVariables & { children: React.ReactNode }) => {
  const { queryClient: _, ...propsWithOutQueryClient } = props;
  const { data: checklist } = useChecklistSuspense({
    variables: propsWithOutQueryClient
  });
  return (
    <ChecklistContext.Provider value={{ ...props, checklist }}>
      {children}
    </ChecklistContext.Provider>
  );
};

export const useChecklistContext = () => {
  const context = useContext(ChecklistContext);
  if (!context) {
    throw new Error(
      "useChecklistContext must be used within a ChecklistProvider"
    );
  }
  return context;
};
